import React from "react";
import RichText from "./RichText";

export default function BulletParagraph(title, content) {
  return (
    <div className="flex gap-[25px]">
      <div>
        <div className="mt-[4px] rounded-full w-[20px] h-[20px] xl:w-[28px] xl:h-[28px] bg-lightGray" />
      </div>
      <div className="flex flex-col gap-[10px] text-left w-full min-w-0">
        <h1 className="text-lead font-bold text-[#333333]">
          {title}
        </h1>
        <RichText html={content} />
      </div>
    </div>
  );
}
